import { createAsyncThunk } from "@reduxjs/toolkit";
import { calculateCartWithOffers } from "../../../utils/APICalls/APICalls";
import { OrderTypesEnum } from "../../../utils/enums";
import envConfig from "../../../utils/env.config";
import { getOrderTypeKeyStringByValue } from "../../../utils/help/orderType/orderType";
import { RootState } from "../app/store";
import { shiftOffersArray } from "../slices/cartAndLoyaltySlice";
import { CartInput, CartOutput } from "../types/CartLoyaltyV2Types";

export const calculateCartWithOffersCall = createAsyncThunk(
  "calculateCartWithOffersCall",
  // eslint-disable-next-line
  async (params: { retryCount?: number }, { getState, dispatch }) => {
    const state = getState() as RootState;
    const cartInput: CartInput = {
      restaurantId:
        state.config.restaurantInfo?.id || parseInt(envConfig.restaurantId!),
      franchiseId: state.cartAndLoyaltyReducer.cart.franchiseId,
      actions: state.cartLoyaltyV2Reducer.cartActions,
      hasRoundingMethodAndLevel:
        state.cartAndLoyaltyReducer.hasRoundingMethodAndLevel,
      servicePercentage: state.config.restaurantInfo?.service || 0,
      vatPercentage: state.config.restaurantInfo?.vat || 0,
      deliveryFees: state.delivery.deliveryFees || 0,
      orderType:
        getOrderTypeKeyStringByValue(state.queryParams.orderTypeParam) ||
        getOrderTypeKeyStringByValue(OrderTypesEnum.TAKE_OUT),
      pointsPerOneCredit:
        state.cartAndLoyaltyReducer.pointingSystem?.pointsPerOneCredit,
      currencyRoundingLevel:
        state.config.restaurantInfo?.currencyRoundingLevel || undefined,
      currencyRoundingMethod:
        state.config.restaurantInfo?.currencyRoundingMethod || undefined,
      deliveryServicePercentageFees:
        state.delivery.currentDeliveryConfig?.extraConfig
          ?.deliveryServicePercentageFees,
      applyDiscountAfterVat:
        state.config.restaurantInfo?.config?.applyDiscountAfterVat,
      calculateVatExcludingServiceFee:
        state.config.restaurantConfig?.calculateVatExcludingServiceFee,
      isTaxInclusive: state.config.selectedFranchise?.isTaxInclusive,
    };
    const cart: { data: CartOutput } = await calculateCartWithOffers(cartInput);

    dispatch(shiftOffersArray(cart.data.redeemedOffer));

    return cart.data;
  }
);
